var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaySquared = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 16h16V0H0zm1.333-1.333h13.334V1.333H1.333z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.333 5.693 10.947 8l-4.614 2.307zm-.978 6.194a.75.75 0 0 0 .732.034l6.497-3.249A.75.75 0 0 0 13 8a.75.75 0 0 0-.416-.672l-6.498-3.25A.75.75 0 0 0 5 4.752v6.498c0 .262.133.5.355.638",
  clipRule: "evenodd"
})));
export default SvgPlaySquared;